<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/sEKn87/tc-custom/9783987449253.jpg?1704424707307" alt="This image is the cover for the book Angel, A Sketch in Indian Ink, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Angel, A Sketch in Indian Ink, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Excerpt: "It was the middle of March in the North-West Provinces, and the hot weather had despatched several heralds to Ramghur, announcing its imminent approach. Punkahs were swinging lazily in barrack rooms, the annual ice notice had made a round of the station, many families had quitted the sweltering cantonments for the misty Himalayas, and the brain fever bird had arrived! Moreover, the red-capped tennis boys were on half-pay, the polo ground was abandoned, the club reading-room had cancelled all the ladies' papers, and its long dim verandah presented a melancholy vista of empty chairs. Outside in the gardens, and all over the district, cork trees, acacias, and stately teak upheld their naked branches, as if in agonised appeal to a pitiless blue sky, whilst their leaves, crisp and shrivelled, choked the neighbouring nullahs, or were chased up and down the dusty plains and roads by a howling hot wind. At a corner where two of these roads met, and about a mile from the club, stood a large irregular bungalow, with a thatched roof and walls of a vivid  pink complexion, as if it were blushing—as well it might—for its straggling and neglected compound. The gate of this was closed, and through its wooden bars a white-faced shabby little girl was gazing intently. Otherwise the premises appeared to be deserted; the servants were presumably smoking and gossiping in the bazaar, the stables were empty, the very dogs were out. No, there was not a living creature to be seen, except a couple of quarrelsome crows and this solitary child. Although Angel Gascoigne had elevated herself by standing on the second rung of the gate, she was unable to lean comfortably on the top bar, but peered below like some caged creature, for she was remarkably small for her age. Indeed, if any of her acquaintance had been suddenly called upon to name it, they would have answered, "Oh—Angel! She is about six." Nevertheless, it was nine years, and long, long years to Angel, since she had come into the world in a damp little bungalow in distant Dalhousie."</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        B. M. Croker
      </h2>
      
      <p class="authorDescription body article">Bithia Mary (or May) Croker (née Sheppard, c. 1848 or 1849[1] – 20 October 1920) was an Irish novelist, most of whose work concerns life and society in British India. Her 1917 novel The Road to Mandalay, set in Burma, was the uncredited basis for a 1926 American silent film, of which only excerpts survive. She was also a notable writer of ghost stories.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3735c9d3